<template>
	<div >
		<!-- 联系人关联 -->
		<div class="workihead FlexBetween">
			<div></div>
			<div class="addarea ">
				<div class="addbtn Flexalign" @click="recyclick(1)">
					<i class="el-icon-plus"></i>
					添加
				</div>
			</div>
		</div>
		
		<div class="workiaddlist">
			<div class="add_item Flexalign" v-for="(item1, index1) in addlist" >
				<div class="search_create_box">
					<div class="search_input Flexalign">
					
						<el-input v-model="item1.content_name"  :disabled="item1.content_id != ''"
						@focus="searchFocus($event, index1)"
						@blur="searchBlur($event, index1)" placeholder="联系人姓名"
						@input="search_change($event, index1)"></el-input>
						<div v-show="item1.content_name" class="dclearable" @click="dclearable(index1)">
							<i class="el-icon-close"></i>
						</div>
						<div class="dropdown" :class="{'isdown': item1.isdown}">
							<i class="el-icon-arrow-down"></i>
						</div>
						
						
					</div>
					
					
					<div class="search_resbox" :id="'select' + (index1 + 1)" v-show="item1.isdown">
						<div class="res_item FlexBetween" 
						@click="setSearchVal(index1, dval)"
						:class="{'isActive': dval.isActive}" 
						v-for="(dval, dindex) in item1.downlist">
							<div class="Flexalign">
								<div class="code" v-if="dval.codeVal">
									{{dval.codeVal || ''}}
								</div>
								<div class="title Singlerow">
									{{dval.name || ''}}
								</div>
							</div>
							
						</div>
						<div class="nodatxt" v-if="item1.downlist.length == 0">
							暂无数据
						</div>
						
					</div>
				</div>
				
				<div class="member_select">
					<el-input v-model="item1.phone"  :disabled="item1.content_id != ''"
					placeholder="联系人手机" maxlength="20" oninput="value=value.replace(/[^0-9.]/g,'')"
					></el-input>
					
					
				</div>
				
				<div class="operate_box Flexalign">
					<el-button class="create" v-show="item1.isnew" @click="newclick(index1)">
						 新建
					</el-button> 
					<el-button class="create" v-show="item1.isadd" @click="craddclick(index1)">
						 添加
					</el-button>
					<el-button class="close" @click="closeclick(index1)">
						 取消
					</el-button>
				</div>				
				
			</div>
		</div>
		
		
		<div class="worki_content">
			<div class="worki_line Flexalign" v-for="(item1, index1) in contentlist">
				<div class="detail_links Flexalign">
					<div class="links_txt FlexRow">
						{{item1.codeVal || ''}}
					</div>
				</div>
				<div class="worki_val Flexalign">
					<div class="icon_box FlexRow">
						<i class="iconfont icon-a-lujing131"></i>
					</div>
					<div class="ctxt">
						{{item1.name || ''}}
					</div>
				</div>
				<div class="member_area Flexalign" v-if="item1.phone">
					
					<div class="icon_box FlexRow">
						<i class="el-icon-phone"></i>
					</div>
					
					<div class="txt">
						{{item1.phone || ''}}
					</div>
				</div>
				
				<div class="cancelbtn">
					<el-dropdown>
						<div class="addbtn Flexalign">
							<i class="el-icon-more"></i>
						</div> 
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="1" @click.native="cancelbtn(1, item1)" >删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="nodatxt" v-if="contentlist.length == 0">
				暂无数据
			</div>
		</div>
		
		
	</div> 
</template>

<script>
	import {
		deepEqual,
		deepStrs,
		fn_retjson,
		retJSONArr,
		Basics_field,
		checkStr,
	} from "network/defaults";
	var that;
	
	import {
		
		get_module_comtomer,
		get_customer_form_id,
		lxrl_list_contact,
		lxrl_edit_contact,
		lxrl_add_contact,
		lxrl_del_contact,
		getfollow_up_list,
	} from "network/hk_customer";
	export default {
		name: 'contactassoc',
		props: {
			types: { // 1 线索， 2 客户,  
				type: Number,
				default: 1,
			},
			isshow: {
				type: Boolean,
				default: false,
			},
			
			currentRote: { // 1.联系人
				type: Number,
				default: 1,
			},
			content_id: {  // 当前打开详情页的id
				type: Number,
				default: 0,
			},
			
			memberlist: {
				type: Array,
				default: ()=>{
					return []
				},
			},
			infos:{
				type: Object | String,
				default: '',
			},
			
		},
		components: {
			
		},
		watch: {
			isshow(){
				this.contentlist = []
				if(this.isshow) {
					this.cleardata() 
				}
			},
			// 
			scrollBottom(val) {
				if (val < 20) {
					if (this.selectobj.page < this.selectobj.last_page) {
						this.selectobj.page++
						this.getsubclass(this.cursearch_name, this.cursearch_Index)
					}
				}
			},
		},
		created(){
			this.setdatas()
			this.cleardata() 
		},
		methods: {
			// 开局设置数据
			setdatas(){
				if(this.currentRote == 1) {  // 联系人
					this.c_projcet_div_id = 6
				}
			},
			// 取消 删除
			closeclick(index1){
				this.addlist.splice(index1, 1)
			},
			// 搜索框聚焦
			searchFocus(e, index){
				let obj = this.addlist[index]
				let search_name = obj.content_name || '';
				this.curselectid = `#select${index + 1}`
				this.cursearch_name = search_name 
				this.cursearch_Index = index 
				clearTimeout(this.FocusTimer);
				this.addlist[index].downlist = []
				this.FocusTimer = setTimeout(() => {
					this.getsubclass(search_name, index); // 定时器生效时执行的方法
					this.fn_startatu()
				}, 500);
			},
			
			fn_startatu() {
				if(this.curselectid) {
					// 首次加载页面的时候给列表元素添加 滚动的事件监听
					this.filelists = document.querySelector(this.curselectid)
					document.querySelector(this.curselectid).addEventListener('scroll', this.hanleScroll, true)
				}
			},
			hanleScroll() {
				this.scrollBottom = (document.querySelector(this.curselectid).scrollHeight - document.querySelector(
					this.curselectid).clientHeight) - document.querySelector(this.curselectid).scrollTop
			},
			
			// 搜索框失焦
			searchBlur(e, index){
				clearTimeout(this.BlurTimer);
				this.clearpage()
				this.BlurTimer = setTimeout(() => {
					if(this.addlist[index]) {
						this.addlist[index].isdown = false
						let content_id = this.addlist[index].content_id
						this.addlist[index].downlist = this.addlist[index].downlist.filter(v=>v.contact_id == content_id)
					}
				}, 500)
			}, 
			// 搜索内容改变
			search_change(e, index){
				clearTimeout(this.changeTimer);
				this.addlist[index].downlist = []
				this.changeTimer = setTimeout(() => {
					this.clearpage()
					this.getsubclass(e,index); // 
				}, 500);
			},
			clearpage(){
				this.selectobj.pagesize = 30
				this.selectobj.page = 1
				this.selectobj.last_page = 0
			},
			// 清空当前搜索和选择内容
			dclearable(index){
				let obj = this.addlist[index]
				obj.content_name = ''
				obj.content_id = ''
				obj.phone = ''
				obj.isnew = true
				obj.isadd = false
				
			},
			// 搜索结果点击选择
			setSearchVal(index1, dval){
				if(dval) {
					let obj = this.addlist[index1]
					let content_id = dval.contact_id
					obj.content_name = dval.name
					obj.content_id = content_id
					obj.phone = dval.phone
					obj.isnew = false
					obj.isadd = true
				}
			},
			// 输入名称搜索数据
			getsubclass(search_name, index){
				let obj = this.addlist[index]
				let data = {
					sort_type: 1, 
					pagesize: this.selectobj.pagesize, 
					page: this.selectobj.page,
					type: obj.type,
					class_type: 0,
					search_type: 1,
				};
				if (search_name) {
					data.search_name = (search_name + '').trim();
				}
				if(!this.$clickgate()) return;
				this.getdatasList(data, index)
			},
			// 添加
			recyclick(flag){
				if(this.addlist.length == 0) {
					let member_id = localStorage.member_id * 1;
					let newEle = {
						member_id,
						content_name: '',
						content_id: '',
						phone: '',
						isdown: false,
						downlist: [],
						isnew: true,
						isadd: false,
					}
					this.addlist.push(newEle)
				}
			},
			
			
			// 获取已关联 列表数据
			getDamand_son(){
				let data = {
					sort_type: 1, 
					pagesize: 999, 
					page: 1,
					class_type: 0,		
				};
				if(this.types == 1) { // 线索
					data.cue_id = this.content_id
				}
				else if(this.types == 2) { // 客户
					data.customer_id = this.content_id
				}
				this.getdatasList(data)
			},
			// 获取未关联 列表数据
			getdatasList(data, index) {
				lxrl_list_contact(data).then((res) => {
					if (!res) return
					let obj = res.result.data || []
					for(let item of obj) {
						item.isActive = false
						item.codeVal = item.lx_code || '' 
					}
					let newArr = obj.filter(v=> v.is_main != 1)
					if(index != undefined) {
						let arr = []
						// 不是已关联的数据
						if(this.types == 1) { // 线索
							arr = newArr.filter(v=>{
								return !v.cue_id && v.cue_id != this.content_id
							})
						}
						else if(this.types == 2) { // 客户
							arr = newArr.filter(v=>{
								return !v.customer_id && v.customer_id != this.content_id
							})
						}
						this.addlist[index].downlist = this.addlist[index].downlist.concat(arr)
						this.addlist[index].isdown = true
						this.selectobj.last_page = res.result.last_page || 0
					}
					else {
						this.contentlist = obj
						let len = this.contentlist.length || 0;
						this.$emit('retnum', len)
					}
				});
			},
			cancelbtn(flag, item1){  // 取消 关联
				if(flag == 1) {
					this.fn_delContact(item1.contact_id)
				}
			},
			craddclick(index1){  // 添加 
				let obj =  this.addlist[index1]
				let curretnobj = obj.downlist[0] ? obj.downlist[0] : [];
				let resdata = new FormData();
				resdata.append("contact_info", curretnobj.contact_info);
				resdata.append("contact_id", obj.content_id);  // 联系人id
				if(this.types == 1) {
					resdata.append('cue_id', this.content_id); // 线索id
					resdata.append('relation_type', 1);
				}
				else if(this.types == 2) {
					resdata.append('customer_id', this.content_id); // 客户id
					resdata.append('relation_type', 2);
				}
				lxrl_edit_contact(resdata).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess('更新成功')
						this.cleardata()
					}
				});
			}, 
			newclick(index1){ // 新建
				let obj = this.addlist[index1]
				let name = (obj.content_name + '').trim()
				if(!name){
					this.$alertMess('请填写联系人姓名','error')
				}
				else if(!checkStr(obj.phone, 'phone')) {
					this.$alertMess('请正确填写手机号','error')
				}
				else {
					this.currentclickObj = obj
					this.field_create = []
					this.fn_follow_up_list()
				}
			},
			// 获取客户来源
			fn_follow_up_list() {
				if(this.source_select.length) {
					this.getmodulelist(this.c_projcet_div_id)
				}
				else {
					getfollow_up_list().then((res) => {
						if (this.$handlereq(res)) {
							this.source_select = res.result.data;
							this.getmodulelist(this.c_projcet_div_id)
						}
					});
				}
				
			},
			// 获取所有字段模板 1级模板
			getmodulelist(projcet_div_id) {
				get_module_comtomer(projcet_div_id).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || []
						if (obj.length) {
							for (let item of obj) {
								item.id = item.form_id
							}
						};
						// 新建默认选择系统模板 使用 form_id 2级模板
						let form_id = obj[0].form_id || '';
						// 2级模板id
						this.currentMod_id = form_id;
						this.getmoduleField(projcet_div_id, this.currentMod_id)
					}
				});
			},
			// 获取当前选用模板下的所有字段信息  获取2级模板
			getmoduleField(projcet_div_id, form_id) {
				get_customer_form_id(form_id, 1, projcet_div_id).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || [];
						// 赋值改动字段
						this.handle_data(obj)
						this.field_create = obj
						this.fnCreateSave()
					}
				})
			},
			//    
			handle_data(data) {
				for (let item of data) {
					let field_sign = item.field_sign || item.field;
					if (field_sign == '联系人姓名') {
						item.field_type = 1
						if (this.currentclickObj) {
							item.select_field = item.content = this.currentclickObj.content_name
						}
					} else if (field_sign == '联系人模板') {
						item.content = this.currentMod_id
						item.field_type = 18
					} else if (field_sign == '联系人来源') {
						item.field_type = 5
						if (this.source_select[0]) {
							item.select_field = this.source_select[0].name
							item.content = this.source_select[0].id
						}
					} else if (field_sign == '手机') {
						item.field_type = 1
						if (this.currentclickObj) {
							item.select_field = item.content = this.currentclickObj.phone
						}
					} 
					else if (field_sign == '性别') {
						item.field_type = 5
						item.select_field = '男'
						item.content = 1
					}
				}
			},
			// 新建,编辑保存
			fnCreateSave() {
				let uarr = []
				let tsarr = []
				if(this.currentRote == 1) {
					uarr = this.Referencelxr
				}
				let resdata = this.fn_Savedatas(uarr)
				if(this.types == 1) {
					resdata.append('cue_id', this.content_id); // 线索id
					resdata.append('relation_type', 1);
				}
				else if(this.types == 2) {
					resdata.append('customer_id', this.content_id); // 客户id
					resdata.append('relation_type', 2);
				}
				let currobj = this.field_create;
				let newArr = Basics_field(currobj); 
				resdata.append("contact_info", JSON.stringify(newArr));
				lxrl_add_contact(resdata).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("新建成功");
						this.cleardata()
					}
				});
				
			},
			cleardata(){
				this.currentMod_id = ''
				this.field_create = []
				this.codeVal = ''
				this.currentclickObj = ''
				this.getDamand_son()
				this.addlist = []
			},
			// 保存数据处理
			fn_Savedatas(uarr) {
				let fd = new FormData();
				for (let i = 0; i < uarr.length; i++) {
					let {
						name,
						key
					} = uarr[i]
					let res_ = this.findfont(name)
					if(res_) {
						fd.append(key, res_);
					}
				}
				let assistant = this.findfont("协同人") || '';
				if (assistant && assistant.length) {
					// 	否	string	协同人id	逗号间隔 加 逗号
					fd.append("assistant_member_id", assistant.join(",") + ",");
				}
				return fd;
			},
			
			findfont(field) {
				if (this.field_create.length) {
					let index = this.field_create.findIndex((v) => v.field_sign == field || v.field == field);
					if (index != -1) {
						return this.field_create[index].content;
					} else {
						return "";
					}
				}
			},
			
			// 删除联系人
			fn_delContact(contact_id) {
				lxrl_del_contact(contact_id).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("删除成功");
						this.cleardata()
					}
				});
			},
			
		},
		data() {
			return {
				scrollBottom: 0,
				
				filelists: null,
				curselectid:'',
				cursearch_name: '',
				cursearch_Index: -1,
				selectobj: { 
					pagesize: 30,
					page: 1,
					last_page: 0,
				},
				
				source_select: [],
				contentlist: [],
				
				field_create: [],
		
				codeVal: '',
				
				c_projcet_div_id: 6,
			
				currentMod_id: '',
				
				currentclickObj: '',
			
				addlist: [],
				Statuslist: [],
				Levellist: [],
				FocusTimer: null,
				changeTimer: null,
				BlurTimer: null,
				
				Referencelxr: [{
						key: 'name',
						name: '联系人姓名',
					},
					{
						key: 'phone',
						name: '手机',
					},
					{
						key: 'source',
						name: '联系人来源',
					},
					{
						key: 'email',
						name: '邮箱',
					},
					{
						key: 'job',
						name: '职务',
					},
					{
						key: 'qq',
						name: 'QQ号',
					},
					{
						key: 'wx',
						name: '微信号',
					},
					{
						key: 'gender',
						name: '性别',
					},
					{
						key: 'form_id',
						name: '联系人模板',
					},
				],
				
				ReferenceKehu: [{
						key: 'name',
						name: '客户名称',
					},
					{
						key: 'phone',
						name: '电话',
					},
					{
						key: 'customer_type',
						name: '客户类型',
					},
					{
						key: 'industry',
						name: '企业行业',
					},
					{
						key: 'source',
						name: '客户来源',
					},
					{
						key: 'email',
						name: '邮箱',
					},
					{
						key: 'qy_name',
						name: '企业名称',
					},
					{
						key: 'form_id',
						name: '客户模板',
					},
					{
						key: 'cust_code',
						name: '客户编号',
					},
				],
				
				
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "./assoc.scss";
</style>